<router-outlet></router-outlet><max-loader *ngIf="loading"></max-loader>